import * as React from "react"
import { Helmet } from "react-helmet"

declare global {
  interface Window {
    turnstile?: { reset: () => void }
  }
}

function ContactForm() {
  const [sending, setSending] = React.useState(false)
  const [sent, setSent] = React.useState(false)
  const [formMessage, setFormMessage] = React.useState("")
  const [fieldErrors, setFieldErrors] = React.useState<Record<string, string>>({})
  const form = React.useRef<HTMLFormElement>(null)

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault()
    setSending(true)
    setFieldErrors({})
    setFormMessage("")

    const formData = new FormData(form.current!)
    const body = new URLSearchParams(formData as unknown as Record<string, string>).toString()

    try {
      const res = await fetch("https://email-worker.mattdoesdev.workers.dev", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body,
      })
      const json = await res.json()

      if (json.success) {
        setFormMessage("Your message was sent! Thank you.")
        form.current?.reset()
        setSent(true)
        window.turnstile?.reset()
      } else if (json.fields) {
        setFieldErrors(json.fields)
        window.turnstile?.reset()
      } else {
        setFormMessage(json.error || "There was an error sending your message. Please try again later.")
        window.turnstile?.reset()
      }
    } catch {
      setFormMessage("There was an error sending your message. Please try again later.")
      window.turnstile?.reset()
    } finally {
      setSending(false)
    }
  }

  if (sent) {
    return (
      <div className="pt-5 lg:pt-20 pb-10">
        <p className="font-semibold text-white">{formMessage}</p>
      </div>
    )
  }

  return (
    <>
      <Helmet>
        <script src="https://challenges.cloudflare.com/turnstile/v0/api.js" async defer />
      </Helmet>

      <form ref={form} onSubmit={handleSubmit}>
        {/* honeypot — visible to bots, hidden from humans */}
        <input
          type="text"
          name="website"
          tabIndex={-1}
          autoComplete="off"
          style={{ position: "absolute", left: "-9999px", opacity: 0, pointerEvents: "none" }}
        />

        <input
          name="name"
          type="text"
          placeholder="NAME"
          className="contact-form-input mb-8"
          required
        />
        {fieldErrors.name && <p className="text-red-400 text-sm -mt-6 mb-6">{fieldErrors.name}</p>}

        <input
          name="phone"
          type="tel"
          placeholder="PHONE"
          className="contact-form-input mb-8"
        />

        <input
          name="email"
          type="email"
          placeholder="EMAIL"
          className="contact-form-input mb-8"
          required
        />
        {fieldErrors.email && <p className="text-red-400 text-sm -mt-6 mb-6">{fieldErrors.email}</p>}

        <textarea
          rows={5}
          name="message"
          className="contact-form-textarea mb-8"
          placeholder="MESSAGE"
          required
        />
        {fieldErrors.message && <p className="text-red-400 text-sm -mt-6 mb-6">{fieldErrors.message}</p>}

        <div className="mb-8">
          <div
            className="cf-turnstile"
            data-sitekey="0x4AAAAAADrWPYGO09LJH7AV"
            data-theme="dark"
          />
        </div>

        <input
          type="submit"
          className="bg-transparent cursor-pointer hover:text-secondary transition-colors uppercase text-white font-bold disabled:opacity-50"
          value={sending ? "Sending..." : "Send Now"}
          disabled={sending}
        />

        {formMessage && <p className="text-white mt-4">{formMessage}</p>}
      </form>
    </>
  )
}

export default ContactForm
